import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Modal } from '@/shared/components/Modal';
import { Input } from '@/shared/components/Input';
import { Button } from '@/shared/components/Button';
export function RenameModal({ open, title, initialValue, onClose, onSubmit, loading, error, }) {
    const [value, setValue] = useState(initialValue);
    useEffect(() => {
        if (open)
            setValue(initialValue);
    }, [open, initialValue]);
    function handleSubmit(e) {
        e.preventDefault();
        const trimmed = value.trim();
        if (!trimmed)
            return;
        onSubmit(trimmed);
    }
    return (_jsx(Modal, { open: open, onClose: onClose, title: title, size: "sm", children: _jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col gap-4", children: [_jsx(Input, { label: "Nombre", autoFocus: true, value: value, onChange: (e) => setValue(e.target.value), ...(error ? { error } : {}) }), _jsxs("div", { className: "flex justify-end gap-2", children: [_jsx(Button, { variant: "secondary", type: "button", onClick: onClose, children: "Cancelar" }), _jsx(Button, { type: "submit", loading: !!loading, disabled: !value.trim() || value.trim() === initialValue, children: "Guardar" })] })] }) }));
}
//# sourceMappingURL=RenameModal.js.map